

































































import { Mixins, Component } from "vue-property-decorator"
import PageHeader from "@/components/page-header/index.vue"
import { mapGetters } from "vuex"
import { LogColumns, detailInfo, AutoDeploy } from "./constant"
import policyService from "@/services/policy.service"
import PageMixin from "@/mixins/page"
import config from "@/config"
@Component({
    components: {
        PageHeader
    },
    computed: {
        ...mapGetters(["currentUser", "allUser"]),
        ...mapGetters("common", [
            "software_list",
            "productSubTypeMap",
            "areaMap",
            "preparationStatusMap",
            "PolicyStatusMap",
            "syncWayMap",
            "textTypeMap"
        ])
    }
})
export default class ContrastDetail extends Mixins(PageMixin) {
    readonly software_list: any
    readonly productSubTypeMap: any
    readonly areaMap: any
    readonly preparationStatusMap: any
    readonly syncWayMap: any
    readonly PolicyStatusMap: any
    readonly textTypeMap: any
    readonly detailInfo = detailInfo
    readonly logColumns = LogColumns
    loading = false
    detail = {}
    logData: any = []
    activeTab = "basic"
    contrast_id: any = undefined
    platform_id = config.api.PID

    created() {
        this.contrast_id = Number(this.$route.query.id)
        this.getDetail()
    }

    userInfo(uid: number) {
        return this.allUser[uid] || null
    }

    changeTab() {
        if (this.activeTab === "log") {
            this.getLogList()
        }
    }

    openUrl(url: string) {
        if (url) {
            window.open(url)
        }
    }

    toEdit() {
        this.$router.push({
            path: "/channel/contrast-edit",
            query: {
                id: String(this.contrast_id)
            }
        })
    }

    async getDetail() {
        try {
            this.loading = true
            const res = await policyService.getComparePolicy({
                id: this.contrast_id
            })
            const { sync_way, area, text_type, auto_deploy } = res
            this.detail = {
                ...res,
                sync_way: this.syncWayMap[sync_way] || "-",
                area: this.areaMap[area] || "-",
                text_type: this.textTypeMap[text_type] || "-",
                auto_deploy: AutoDeploy[auto_deploy]
            }
        } catch (error) {
            this.$message.error(`${error}`)
        } finally {
            this.loading = false
        }
    }

    async getLogList() {
        try {
            const { current, pageSize } = this.pagination
            const payload = {
                offset: pageSize * (current - 1),
                limit: pageSize,
                id: this.contrast_id
            }
            const res: any = await policyService.getComparePolicyRecord(payload)
            const { list = [] } = res || {}
            // this.pagination.total = total || 0
            this.logData = list || []
        } catch (error) {
            this.$message.error(`${error},操作记录获取失败！`)
        }
    }
}
